import React from "react"
import { useState, useEffect } from 'react';
import compareVersions from 'compare-versions';
import ReactTooltip from 'react-tooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { Typography, IconButton, Link } from "@material-ui/core";
import { Grid } from "@material-ui/core";

export type UpdateProps = {
    fotaUrl?: FotaBaseUrls
    currentAppVersion: string | undefined
    fotaServer?: FotaChannels
    fotaProduct: FotaProducts
    modemType?: number 
}

export enum FotaBaseUrls {
    Dev = 'https://fotadev.acuitynext.io/',
    QA = 'https://fotaqa.acuitynext.io/',
    Prod = 'https://fota.acuitynext.io/'
}

export enum FotaChannels {
    Dev = 'dev',
    Testing = 'testing',
    Stable = 'stable'
}

export enum FotaProducts {
    Modem = 'modem',
    Transporter = 'transporter'
}

const versionPattern = new RegExp('[0-9]+(?:\.[0-9]+){2,3}');
export const SensorViewSetupUrl = 'https://fota.acuitynext.io/v1/updates/sensorview/stable/svsetup/installer/latest/SensorView_Setup.exe';
export function FirmwareUpdate(props: UpdateProps) {

    let newVersionAvailable = -2;    
    const baseUrl = props.fotaUrl ?? process.env.REACT_APP_ENV_FOTA_URL;
    const server = props.fotaServer ?? process.env.REACT_APP_ENV_FOTA_CHANNEL;
    const product = props.fotaProduct;
    const modemTypeDict: { [key: number]: string } = {
        0: "rut240",
        1: "rut241",
    };
    const modem = modemTypeDict[props.modemType == undefined ? 0 : props.modemType];
    const fotaLatestUrl = baseUrl + 'v1/updates/odin/' + server +
        (product == FotaProducts.Modem ? `/${modem}/app/latest/` : `/${product}/app_package/`);

    const [filenames, setFilenames] = useState<string[] | undefined>([])

    useEffect(() => {
        fetch(fotaLatestUrl)
            .then(response =>
                response.json())
            .then(res => setFilenames(res))
            .catch(iss => setFilenames(undefined))
    }, [baseUrl, server, (product == FotaProducts.Modem ? modem : product), props.currentAppVersion, setFilenames]);

    const currentVersion = versionPattern.exec(props.currentAppVersion ?? '');
    let updateFilename = '';
    let latestVersion;
    let sortedVersionList: string[];
    if (filenames && product === FotaProducts.Modem) {
        updateFilename = filenames[0] ?? '';
        latestVersion = versionPattern.exec(updateFilename);
    }
    // The Transporter does not include version info in its filename under the "latest" path in Fota
    // E.g ../odin/dev/transporter/app_package/latest/Transporter.msi
    else if (filenames && product === FotaProducts.Transporter) {
        let versionList = filenames.map(a => versionPattern.exec(a)).filter(a => a !== null && a !== undefined && a.length > 0).map(a => a ? a[0] : "");
        versionList = versionList.sort((a,b) => compareVersions(a ,b));
        latestVersion = [versionList[versionList.length - 1]];
    }
    //modified this conditional to include 'undefined' as well as 'null'
    if (currentVersion != null && latestVersion != null && !(latestVersion[0] == undefined || currentVersion[0] == undefined)) {
        newVersionAvailable = compareVersions(latestVersion[0], currentVersion[0]);
    }

    return (
        <Grid container spacing={1} alignItems='baseline'>
            <Grid item>
                <Typography><b>Update: </b></Typography>
            </Grid>
            <Grid item>
                {filenames === undefined ? <Typography>Failed to get latest version</Typography>
                    : filenames.length === 0 ? <Typography>Checking for updates...</Typography>
                        : newVersionAvailable > 0 ? displayUrl()
                            : <Typography>No new update available</Typography>}
            </Grid>
            <Grid item>
                <Typography>{newVersionAvailable > 0 ? `New Version: ${latestVersion}` : ''}</Typography>
            </Grid>
        </Grid>
    )

    function displayUrl() {
        const updateFileUrl = (product == FotaProducts.Modem) ? fotaLatestUrl + updateFilename : SensorViewSetupUrl;
        const updateInstructionsText = product == FotaProducts.Modem ?
            'Copy firmware URL and provide in the Modem management portal' : 'Use the installer to upgrade to the latest version of the Transporter';
        return <>

            <Link href={updateFileUrl}>{updateFileUrl}</Link>
            <IconButton aria-label="copy" onClick={function () { navigator.clipboard.writeText(updateFileUrl); }}>
                <FileCopyIcon data-tip data-for='updateInstructions' fontSize='small' />
            </IconButton>
            <ReactTooltip id='updateInstructions' >{updateInstructionsText}</ReactTooltip>
        </>;
    }
}


